import 'bootstrap-daterangepicker/daterangepicker.css';
// import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useRef, useState } from 'react';
import { DateRangePicker } from 'react-bootstrap-daterangepicker';
// you will need the css that comes with bootstrap@3. if you are using
// a tool like webpack, you can do the following:
// you will also need the css that comes with bootstrap-daterangepicker
import { TextField } from '@mui/material';
import momentZ from 'moment';
import IcCalendar from '@assets/jsx-icon/IcCalendar';
// var momentTimeZone = require('moment-timezone');

interface DateRangeValue {
    startDate?: Date;
    endDate?: Date;
}

type Props = {
    value?: DateRangeValue;
    onChange?(value: DateRangeValue): void;
    initialSettings?: any;
    label?: string;
    timezone: string;
};

// const userTimezone = momentZ.tz.guess();
// momentZ.tz.setDefault(userTimezone);
// console.log(`userTimezone:`, userTimezone);

const RESET_OPTION = 'Reset date';

export default function StyledDateRangePicker(props: Props) {
    const moment = (inp?: momentZ.MomentInput) => {
        return momentZ(inp).tz(props.timezone);
    };

    console.log('utcOffset' + moment().utcOffset() / 60, moment().local().utcOffset());
    const initState = props.value || { startDate: moment().toDate(), endDate: moment().toDate() };
    const [dateRange, setDateRange] = useState<DateRangeValue>(initState);
    const value =
        !dateRange?.startDate || !dateRange.endDate
            ? ''
            : moment(dateRange.startDate).format('DD/MM/YYYY') + ' - ' + moment(dateRange.endDate).format('DD/MM/YYYY');

    const keyRef = useRef(Date.now());
    const handleChangeRanges = () => {
        keyRef.current = Date.now();
    };

    useEffect(() => {
        setDateRange(props.value || initState);
        if (!(props.value?.endDate && props.value.startDate)) {
            handleChangeRanges();
        }
    }, [props.value]);

    useEffect(() => {
        momentZ.tz.setDefault(props.timezone);
    }, [props.timezone]);

    return (
        <DateRangePicker
            key={keyRef.current}
            initialSettings={{
                autoApply: true,
                ranges: {
                    Today: [moment(), moment()],
                    Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Last 7 days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 days': [moment().subtract(29, 'days'), moment()],
                    'This month': [moment().startOf('month'), moment().endOf('month')],
                    'Last month': [
                        moment().subtract(1, 'month').startOf('month'),
                        moment().subtract(1, 'month').endOf('month'),
                    ],
                    'Reset date': [undefined, undefined],
                },
                alwaysShowCalendars: true,
                startDate: dateRange?.startDate ? moment(dateRange.startDate) : undefined,
                endDate: dateRange?.endDate ? moment(dateRange.endDate) : undefined,
                opens: 'left',
                ...props.initialSettings,
            }}
            onApply={(e, date) => {
                const isSelectResetDate = date.chosenLabel === RESET_OPTION;
                const { startDate, endDate } = date;
                const _stateDate = (startDate as momentZ.Moment).toDate();
                const _endDate = (endDate as momentZ.Moment).toDate();
                const start = isSelectResetDate ? undefined : _stateDate;
                const end = isSelectResetDate ? undefined : _endDate;
                console.log(`start:`, start, end);

                setDateRange({ startDate: start, endDate: end });
                props.onChange?.({ startDate: start, endDate: end });
            }}
        >
            <TextField
                label={props.label ?? 'Range date'}
                placeholder="Select date range"
                value={value}
                InputProps={{
                    readOnly: true,
                    endAdornment: <IcCalendar width={24} height={24} color="gray" />,
                }}
                fullWidth
                sx={{
                    '& *': {
                        cursor: 'pointer',
                    },
                    display: 'flex',
                    justifyContent: 'center',
                }}
            />
        </DateRangePicker>
    );
}
